import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';

import { CitydetailPage } from './citydetail.page';

// BS modules
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslationModalModule } from '../../components/translation-modal/translation-modal.module';

const routes: Routes = [
  {
    path: '',
    component: CitydetailPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule,
    ReactiveFormsModule,
    RouterModule.forChild(routes),
    TranslationModalModule
  ],
  declarations: [CitydetailPage]
})
export class CitydetailPageModule {}
